import { AController } from "@eagerlogic/react-mvc";
import { ExportModel } from "../model/ExportModel";
import { ApiKeyRpc } from "rpc/settings/ApiKeyRpc";

export class ExportController extends AController<ExportModel> {

    protected createInitialModel(): ExportModel {
        this.loadData();
        
        var res: ExportModel = new ExportModel();
        res.isInit = true;

        return res;
    }

    private async loadData() {
        var apiKey = await ApiKeyRpc.get();
        this.model.apiKey = apiKey.value;
        this.model.isInit = false;

        this.render(this.model);
    }

    public async onGenerateApiKeyClicked() {
        this.model.apiKey = (await ApiKeyRpc.generate()).value;
        this.render(this.model);
    }

    public async onRevokeApiKeyClicked() {
        await ApiKeyRpc.revoke();
        this.model.apiKey = null;
        this.render(this.model);
    }

}